import React, { useEffect, useRef, useState } from 'react';
import SearchIcon from '@material-ui/icons/Search';
import EditIcon from '@material-ui/icons/Edit';
import {
    TextField,
    Card,
    Breadcrumbs,
    Link,
    Typography,
    CardContent,
    Container,
    Grid,
    Backdrop,
    CircularProgress,
    Button,
    Snackbar,
    ThemeProvider,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    List,
    ListItem,
    ListItemText,
    ListItemSecondaryAction,
    Chip,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import Page from 'src/components/Page';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import moment from 'moment';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import { useMailOrbitEnabled } from 'src/utils/mailorbitFeature';
import Alert from 'src/components/Alert';
import trLocale from 'date-fns/locale/tr';
import DateFnsUtils from '@date-io/date-fns';
import { createMuiTheme } from '@material-ui/core/styles';
import { connect, useDispatch } from 'react-redux';
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider
} from '@material-ui/pickers';
import { useHistory } from 'react-router-dom';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
    getTasksRequest
} from '../../store/actions';
import { getExternalSystemDatasRequest, setExternalSystemFilterModel } from 'src/store/actions/externalSystemActions';
import ExcelExport from 'src/components/ExcelExport';
import { useSelector } from 'react-redux';
import { useCooldown } from 'src/hooks/useCooldown';

// System ve Tenant bazlı konfigürasyon
const SYSTEM_CONFIG = {
    Local: {
        channelId: 40,
        tradePartnerChannelId: 39,
        tenantUserType: {
            12: [1171],
            49: [1239],
        },
    },
    Test: {
        channelId: 40,
        tradePartnerChannelId: 39,
        tenantUserType: {
            12: [1171],
            49: [1239],
        },
    },
    Live: {
        channelId: 35,
        tradePartnerChannelId: 34,
        tenantUserType: {
            12: [1171],
            49: [1239],
        },
    },
};

const currentSystem = process.env.REACT_APP_SYSTEM || 'Live';
const currentConfig = SYSTEM_CONFIG[currentSystem] || SYSTEM_CONFIG.Live;

const localeMap = {
    tr: trLocale
};

const locale = localStorage.getItem('i18nextLng');

const siyah = '#424242';


const materialTheme = createMuiTheme({
    palette: {
        primary: {
            contrastText: '#FFFFFF',
            dark: siyah,
            main: siyah,
            light: siyah
        }
    }
});


const useStyles = makeStyles(theme => ({
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0)'
    },
    root: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    cardscontent: {
        minHeight: 300
    },
    backdrop: {
        zIndex: 1500,
        color: '#fff'
    },
    tableRow: {
        '&$hover:hover': {
            backgroundColor: '#E4DCCF'
        }
    },
    tableCell: {
        '$hover:hover &': {
            color: 'black'
        }
    },
    hover: {},
    searchB: {
        flexGrow: 1,
        height: 42,
        padding: theme.spacing(0, 2),
        display: 'flex',
        alignItems: 'center'
    },
    searchIconB: {
        marginRight: theme.spacing(0),
        color: theme.palette.icon
    },
    searchInputB: {
        flexGrow: 1
    },
    searchButtonB: {
        backgroundColor: theme.palette.common.white,
        marginLeft: theme.spacing(2)
    },
    container: {
        maxWidth: '100%',
        overflowX: 'auto'
    },
    table: {
        minWidth: 1400
    },
    noteCell: {
        maxWidth: '300px',
        whiteSpace: 'normal',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    }
}));



const ExternalSystemTasks = ({ getTasksRequest }) => {
    const classes = useStyles();
    const { t } = useTranslation('overview');
    const SessionUser = getUser();
    const history = useHistory();
    // SR-013: kapı açık tenant'ta case owner yönetimi MailOrbit UI'dadır; kolon ve dialog gizlenir.
    const mailOrbitEnabled = useMailOrbitEnabled();
    const [openSnackbar, setOpenSnackbar] = React.useState(false);

    const [loading, setLoading] = useState(false);
    const { isOnCooldown: isExternalTaskCooldownActive, remainingSeconds: externalTaskRemainingSeconds, triggerCooldownByDateRange: triggerTaskCooldownByDateRange } = useCooldown('GetExternalSystemTasks');
    const [ChannelData, setChannelData] = React.useState([]);
    const [IssueTypeData, setIssueTypeData] = React.useState([]);
    const [hoveredRowIndex, setHoveredRowIndex] = useState(null);
    const [StatusData, setStatusData] = React.useState([]);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState(null);
    const topScrollRef = useRef(null);
    const tableScrollRef = useRef(null);
    const topScrollInnerRef = useRef(null);

    const fieldNames = {
        ChannelId: 'ChannelId',
        IssueType: 'IssueType',
        StartDate: 'StartDate',
        EndDate: 'EndDate',
        Status: 'Status',
    };



    const externalData = useSelector((state) => state.externalSystemReducer?.result);

    // Status filter state
    const [statusOptions, setStatusOptions] = useState([]);
    const [statusList, setStatusList] = useState([]);

    // Fetch status list from backend
    useEffect(() => {
        axios.get('/GetStatusList')
            .then(response => {
                setStatusList(response.data || []);
                setStatusOptions([
                    { StatusId: 0, Dsc: t('lblAllStatus') },
                    ...(response.data || [])
                ]);
            })
            .catch(() => {
                setStatusOptions([{ StatusId: 0, Dsc: t('lblAllStatus') }]);
            });
    }, []);

    const externalDataIsLoading = useSelector((state) => state.externalSystemReducer?.isLoading);

    const filterModel = useSelector((state) => state.externalSystemReducer?.filterModel);


    const dispatch = useDispatch();

    const handleChange = e => {
        const { name, value } = e.target;

        dispatch(setExternalSystemFilterModel({ name, value }));
    }

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenSnackbar(false);
    };

    const GetChannels = () => {
        setLoading(true);
        axios
            .get(`/GetChannelsInfo`)
            .then(response => {
                setLoading(false);
                const allChannelOption = { Id: 0, Dsc: t('lblAllChannel') };
                const channelData = [allChannelOption, ...response.data];
                setChannelData(channelData);
                !filterModel?.ChannelId && dispatch(setExternalSystemFilterModel({ name: fieldNames.ChannelId, value: allChannelOption }))

            })
            .catch(error => {
                setLoading(false);
            });
    }

    const GetIssueTypeList = () => {
        setLoading(true);
        axios
            .get(`/GetIssueTypeList`)
            .then(response => {
                setLoading(false);
                const selectIssue = { ID: 0, Description: t('lblAllIssueType') };
                const IssueData = [selectIssue, ...response.data];
                setIssueTypeData(IssueData);
                !filterModel?.IssueType && dispatch(setExternalSystemFilterModel({ name: fieldNames.IssueType, value: selectIssue }));
            })
            .catch(error => {
                setLoading(false);
            });
    }
    const GetStatusList = () => {
        setLoading(true);
        axios.get(`/GetStatusList`)
            .then(response => {
                setLoading(false);
                const allStatusOption = { Id: 0, Dsc: t('lblAllStatus') };
                const statusData = [allStatusOption, ...response.data];
                setStatusData(statusData);
                !filterModel?.StatusId && dispatch(setExternalSystemFilterModel({ name: fieldNames.Status, value: allStatusOption }))
            })
            .catch(error => {
                setLoading(false);
            });
    }


    const GetSiriusUserTypeList = () => {
        axios.get(`/GetSiriusUserTypeList/${SessionUser.TechnicianId}`)
            .then(response => {
                if (response.data.length > 0 && response.data != "") {
                    const allowedTypes = currentConfig.tenantUserType[SessionUser.TenantId] || [];
                    const hasPermission = response.data.some(x =>
                        allowedTypes.includes(x.UserTypeId)
                    );
                    setCanChangeCaseOwner(hasPermission);
                } else {
                    setCanChangeCaseOwner(false);
                }
            })
            .catch(error => {
                setCanChangeCaseOwner(false);
            });
    };

    useEffect(() => {
        GetChannels();
        GetIssueTypeList();
        GetStatusList();
        GetSiriusUserTypeList();
    }, []);

    useEffect(() => {
        if (externalData?.errorDetails !== null) {
            setOpenSnackbar(true);
        }
    }, [externalData])

    const GetExternalSystemTasks = () => {
        triggerTaskCooldownByDateRange(filterModel.StartDate, filterModel.EndDate);
        dispatch(getExternalSystemDatasRequest(
            filterModel.StartDate,
            filterModel.EndDate,
            filterModel.ChannelId.Id,
            filterModel.IssueType.ID,
            filterModel.Status.StatusId || 0
        ));
    }

    const handleRoute = (row) => {
        axios
            .get('/GetConsumerByWorkOrderId/' + row.WorkOrderId + '/' + SessionUser.ServiceShopId + '/' + SessionUser.Role)
            .then(res => {
                const response = JSON.stringify(res.data[0]);
                sessionStorage.removeItem('SearhResult');
                sessionStorage.setItem('SearhResult', response);
                sessionStorage.removeItem('ConsumerId');
                sessionStorage.setItem('ConsumerId', res.data[0].ConsumerId);
                getTasksRequest(row.WorkOrderId);
                history.push(`/WorkOrder/${row.WorkOrderId}/summary`);
            }
            ).catch(err => { });
    }


    const handleMouseEnter = (index) => {
        setHoveredRowIndex(index);
    };

    const handleMouseLeave = () => {
        setHoveredRowIndex(null);
    };

    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const descendingComparator = (a, b, property) => {
        if (b[property] < a[property]) {
            return -1;
        }
        if (b[property] > a[property]) {
            return 1;
        }
        return 0;
    };

    const getComparator = (sortOrder, property) => {
        return sortOrder === 'desc'
            ? (a, b) => descendingComparator(a, b, property)
            : (a, b) => -descendingComparator(a, b, property);
    };

    const stableSort = (array, comparator) => {
        const stabilized = array.map((el, index) => [el, index]);
        stabilized.sort((a, b) => {
            const orderResult = comparator(a[0], b[0]);
            if (orderResult !== 0) {
                return orderResult;
            }
            return a[1] - b[1];
        });
        return stabilized.map((el) => el[0]);
    };

    const syncTopScroll = (event) => {
        if (!tableScrollRef.current || !event?.target) return;
        tableScrollRef.current.scrollLeft = event.target.scrollLeft;
    };

    const syncTableScroll = (event) => {
        if (!topScrollRef.current || !event?.target) return;
        topScrollRef.current.scrollLeft = event.target.scrollLeft;
    };

    useEffect(() => {
        const adjustTopScrollbar = () => {
            if (tableScrollRef.current && topScrollInnerRef.current) {
                topScrollInnerRef.current.style.width = tableScrollRef.current.scrollWidth + 'px';
            }
        };
        adjustTopScrollbar();
        window.addEventListener('resize', adjustTopScrollbar);
        return () => window.removeEventListener('resize', adjustTopScrollbar);
    }, [externalData]);

    const formatDurationFromSeconds = (totalSeconds) => {
        const secondsValue = Number(totalSeconds);
        if (!Number.isFinite(secondsValue)) {
            return '-';
        }

        const absSeconds = Math.max(0, Math.floor(secondsValue));
        const days = Math.floor(absSeconds / 86400);
        const hours = Math.floor((absSeconds % 86400) / 3600);
        const minutes = Math.floor((absSeconds % 3600) / 60);
        const seconds = absSeconds % 60;

        return `${days}d ${hours}h ${minutes}m ${seconds}s`;
    };


    const [caseOwnerDialogOpen, setCaseOwnerDialogOpen] = useState(false);
    const [caseOwners, setCaseOwners] = useState([]);
    const [caseOwnerRow, setCaseOwnerRow] = useState(null);
    const [caseOwnerLoading, setCaseOwnerLoading] = useState(false);
    const [canChangeCaseOwner, setCanChangeCaseOwner] = useState(false);

    const isEmailToCase = filterModel?.ChannelId?.Id === currentConfig.channelId;
    const isTradePartnerChannel = filterModel?.ChannelId?.Id === currentConfig.tradePartnerChannelId;

    const handleOpenCaseOwnerDialog = (e, row) => {
        e.stopPropagation();
        if (!canChangeCaseOwner) {
            return; 
        }
        setCaseOwnerRow(row);
        setCaseOwnerLoading(true);
        setCaseOwnerDialogOpen(true);
        axios.get('/GetCaseOwners')
            .then(res => {
                setCaseOwners(res.data || []);
            })
            .catch(() => setCaseOwners([]))
            .finally(() => setCaseOwnerLoading(false));
    };

    const handleSetCaseOwner = (employeeId) => {
        axios.get(`/SetMailThreadCaseOwner/${caseOwnerRow.WorkOrderId}/${employeeId}`)
            .then(() => {
                setCaseOwnerDialogOpen(false);
                GetExternalSystemTasks();
            })
            .catch(() => setCaseOwnerDialogOpen(false));
    };

    const hasCaseOwner = !mailOrbitEnabled && Array.isArray(externalData?.data) && externalData.data.some(row => row.CaseOwnerName);
    const columns = [
        { id: 'WorkOrderId', label: t('lblWorkOrderId'), align: 'left' },
        { id: 'WorkCaseId', label: t('lblWorkCaseId'), align: 'left' },
        { id: 'Channel', label: t('lblChannel'), align: 'left' },
        { id:'Status', label: t('lblStatus'), align: 'left'},
        { id: 'Issue', label: t('lblIssue'), align: 'left' },
        ...(isTradePartnerChannel ? [{ id: 'TradePartnerPreferredSolution', label: t('lblTradePartnerPreferredSolution'), align: 'left' }] : []),
        ...(isTradePartnerChannel ? [{ id: 'TradePartnerBekoPurcInvoiceNr', label: t('lblTradePartnerBekoPurcInvoiceNr'), align: 'left' }] : []),
        { id: 'IssueType', label: t('lblIssueType'), align: 'left' },
        { id: 'ConsumerFullName', label: t('lblConsumerName'), align: 'left' },
        { id: 'City', label: t('lblCity'), align: 'left' },
        { id: 'District', label: t('lblDistrict'), align: 'left' },
        { id: 'PostCode', label: t('lblPostCode'), align: 'left' },
        { id: 'SKU', label: t('lblSKU'), align: 'left' },
        { id: 'CallCenterNote', label: t('lblCallCenterNote'), align: 'left', className: classes.noteCell },
        { id: 'OpenDate', label: t('lblOpenDate'), align: 'left' },
        { id: 'DaysOpenInSeconds', label: t('lblOpenDays'), align: 'left' },
        { id: 'Dsc', label: t('lblCreateUser'), align: 'left' },
        { id: 'LevelDesc3', label: t('lblProductGroup'), align: 'left' },
        ...(hasCaseOwner ? [{ id: 'CaseOwner', label: t('lblCaseOwner'), align: 'left' }] : []),
        ...(isEmailToCase && canChangeCaseOwner && !mailOrbitEnabled ? [{ id: 'EditCaseOwner', label: t('lblEditCaseOwner') || 'Edit Case Owner', align: 'left', disableSort: true }] : [])
    ];

    const exportData = Array.isArray(externalData?.data)
        ? externalData.data.map(row => {
            const obj = {};
            columns.forEach(col => {
                let value = row[col.id];
                if (col.id === 'OpenDate') {
                    value = moment(row.OpenDate).format('YYYY-MM-DD');
                } else if (col.id === 'DaysOpenInSeconds') {
                    value = formatDurationFromSeconds(row.DaysOpenInSeconds);
                }
                obj[col.label] = value ?? '';
            });
            return obj;
        })
        : [];

    return (
        <Page>
            <Backdrop className={classes.backdrop} open={loading || externalDataIsLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Snackbar
                open={openSnackbar}
                autoHideDuration={3000}
                onClose={handleSnackbarClose}
            >
                <Alert
                    onClose={handleSnackbarClose}
                    message={t(externalData?.errorDetails?.responseDsc)}
                    variant={externalData?.errorDetails?.responseType}
                />
            </Snackbar>
            <Container maxWidth="xl">
                <Breadcrumbs>
                    <Link color="inherit">Sirius</Link>
                    <Typography color="textPrimary">{t('lblExternalSystemTasks')}</Typography>
                </Breadcrumbs>
                <br />
                <Card>
                    <CardContent>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={2} lg={2}>
                                <Autocomplete
                                    size="small"
                                    fullWidth
                                    autoSelect
                                    disableClearable
                                    options={ChannelData}
                                    getOptionSelected={(option, value) => option?.Id === value?.Id}
                                    getOptionLabel={option => (option ? option.Dsc : '')}
                                    value={filterModel?.ChannelId}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            label={t('lblChannel')}
                                            variant="outlined"
                                        />
                                    )}
                                    onChange={(event, value) => {
                                        let e = {
                                            target: {
                                                name: fieldNames.ChannelId,
                                                value: value
                                            }
                                        }

                                        handleChange(e);
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={2} lg={2}>
                                <ThemeProvider theme={materialTheme}>
                                    <MuiPickersUtilsProvider
                                        utils={DateFnsUtils}
                                        locale={localeMap[locale]}
                                    >
                                        <KeyboardDatePicker
                                            color="primary"
                                            inputVariant="outlined"
                                            id="orderDate"
                                            size="small"
                                            invalidDateMessage={t('hatali_tarih')}
                                            format="dd.MM.yyyy"
                                            fullWidth
                                            label={t('lblStartDate')}
                                            variant="outlined"
                                            value={filterModel?.StartDate}
                                            onChange={e => {
                                                let event = {
                                                    target: {
                                                        name: fieldNames.StartDate,
                                                        value: e
                                                    }
                                                }

                                                handleChange(event);
                                            }}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date'
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </ThemeProvider>
                            </Grid>
                            <Grid item xs={12} sm={2} lg={2}>
                                <ThemeProvider theme={materialTheme}>
                                    <MuiPickersUtilsProvider
                                        utils={DateFnsUtils}
                                        locale={localeMap[locale]}
                                    >
                                        <KeyboardDatePicker
                                            color="primary"
                                            inputVariant="outlined"
                                            id="orderDate"
                                            size="small"
                                            invalidDateMessage={t('hatali_tarih')}
                                            format="dd.MM.yyyy"
                                            fullWidth
                                            label={t('lblEndDate')}
                                            variant="outlined"
                                            value={filterModel?.EndDate}
                                            onChange={e => {
                                                let event = {
                                                    target: {
                                                        name: fieldNames.EndDate,
                                                        value: e
                                                    }
                                                }

                                                handleChange(event);
                                            }}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date'
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </ThemeProvider>
                            </Grid>
                            <Grid item xs={12} sm={2} lg={2}>
                                <Autocomplete
                                    size="small"
                                    fullWidth
                                    autoSelect
                                    disableClearable={false}
                                    options={statusOptions}
                                    getOptionLabel={option => option?.Dsc || ''}
                                    value={filterModel?.Status || statusOptions[0]}
                                    getOptionSelected={(option, value) => option?.StatusId === value?.StatusId}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            label={t('lblStatus')}
                                            variant="outlined"
                                        />
                                    )}
                                    onChange={(event, value) => {
                                        let e = {
                                            target: {
                                                name: fieldNames.Status,
                                                value: value
                                            }
                                        };
                                        handleChange(e);
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={2} lg={2}>
                                <Autocomplete
                                    size="small"
                                    fullWidth
                                    autoSelect
                                    disableClearable
                                    options={IssueTypeData}
                                    getOptionSelected={(option, value) => option?.ID === value?.ID}
                                    getOptionLabel={option => (option ? option.Description : '')}
                                    value={filterModel?.IssueType}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            label={t('lblIssueType')}
                                            variant="outlined"
                                        />
                                    )}
                                    onChange={(event, value) => {
                                        let e = {
                                            target: {
                                                name: fieldNames.IssueType,
                                                value: value
                                            }
                                        };

                                        handleChange(e);
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={1} lg={1}>
                                <Button
                                    variant="contained"
                                    style={{
                                        backgroundColor: '#1E5128',
                                        color: 'white',
                                        opacity: isExternalTaskCooldownActive ? 0.5 : 1,
                                    }}
                                    fullWidth
                                    endIcon={<SearchIcon />}
                                    onClick={GetExternalSystemTasks}
                                    disabled={isExternalTaskCooldownActive}
                                >
                                    {isExternalTaskCooldownActive ? t('lblCooldownButton', { seconds: externalTaskRemainingSeconds }) : t('search')}
                                </Button>
                                {isExternalTaskCooldownActive && (
                                    <Typography variant="caption" color="textSecondary" align="center" display="block" style={{ marginTop: 4 }}>
                                        {t('lblCooldownWait', { seconds: externalTaskRemainingSeconds })}
                                    </Typography>
                                )}
                            </Grid>
                            <Grid item xs={12} sm={1} lg={1}>
                                <ExcelExport
                                    JsonData={exportData}
                                    ButtonType={4}
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                    <div
                        ref={topScrollRef}
                        style={{ overflowX: 'auto', overflowY: 'hidden', height: 16 }}
                        onScroll={syncTopScroll}
                    >
                        <div ref={topScrollInnerRef} style={{ height: 1 }} />
                    </div>
                    <TableContainer
                        className={classes.container}
                        ref={tableScrollRef}
                        onScroll={syncTableScroll}
                    >
                        <Table
                            stickyHeader
                            aria-label="sticky table"
                            className={classes.table}
                            size="small"

                        >
                            <TableHead>
                                <TableRow
                                    onClick={(event) => {
                                        event.stopPropagation();
                                    }}
                                >
                                    {columns.map((column) => (
                                        <TableCell
                                            key={column.id}
                                            align={column.align}
                                            className={column.className}
                                            sortDirection={!column.disableSort && orderBy === column.id ? order : false}
                                        >
                                            {column.disableSort ? column.label : (
                                                <TableSortLabel
                                                    active={orderBy === column.id}
                                                    direction={orderBy === column.id ? order : 'asc'}
                                                    onClick={(event) => {
                                                        event.stopPropagation();
                                                        handleRequestSort(column.id);
                                                    }}
                                                >
                                                    {column.label}
                                                </TableSortLabel>
                                            )}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {externalData?.data ? stableSort(
                                    externalData.data,
                                    orderBy ? getComparator(order, orderBy) : () => 0
                                ).map((row, index) => (
                                    <TableRow
                                        key={`${row.WorkOrderId}-${index}`}
                                        hover
                                        classes={{ hover: classes.hover }}
                                        className={classes.tableRow}
                                        onClick={() => handleRoute(row)}
                                        onMouseEnter={() => handleMouseEnter(index)}
                                        onMouseLeave={handleMouseLeave}
                                        style={{ cursor: hoveredRowIndex === index ? 'pointer' : 'default' }}
                                    >
                                        <TableCell align="left">
                                            {row.WorkOrderId}
                                        </TableCell>
                                        <TableCell align="left">
                                            {row.WorkCaseId}
                                        </TableCell>
                                        <TableCell align="left">
                                            {row.Channel}
                                        </TableCell>
                                        <TableCell align="left">
                                            {row.Status}
                                        </TableCell>
                                        <TableCell align="left">
                                            {row.Issue}
                                        </TableCell>
                                        {isTradePartnerChannel && (
                                            <TableCell align="left">
                                                {row.TradePartnerPreferredSolution}
                                            </TableCell>
                                        )}
                                        {isTradePartnerChannel && (
                                            <TableCell align="left">
                                                {row.TradePartnerBekoPurcInvoiceNr}
                                            </TableCell>
                                        )}
                                        <TableCell align="left">
                                            {row.IssueType}
                                        </TableCell>
                                        <TableCell align="left">
                                            {row.ConsumerFullName}
                                        </TableCell>
                                        <TableCell align="left">
                                            {row.City}
                                        </TableCell>
                                        <TableCell align="left">
                                            {row.District}
                                        </TableCell>
                                        <TableCell align="left">
                                            {row.PostCode}
                                        </TableCell>
                                        <TableCell align="left">
                                            {row.SKU}
                                        </TableCell>
                                        <TableCell align="left" className={classes.noteCell}>
                                            {row.CallCenterNote}
                                        </TableCell>
                                        <TableCell align="left">
                                            {moment(row.OpenDate).format('YYYY-MM-DD')}
                                        </TableCell>
                                        <TableCell align="left">
                                            {formatDurationFromSeconds(row.DaysOpenInSeconds)}
                                        </TableCell>
                                        <TableCell align="left">
                                            {row.Dsc}
                                        </TableCell>
                                        <TableCell align="left">
                                            {row.LevelDesc3}
                                        </TableCell>
                                        {hasCaseOwner && <TableCell align="left">{row.CaseOwnerName || ''}</TableCell>}
                                        {isEmailToCase && canChangeCaseOwner && !mailOrbitEnabled && (
                                            <TableCell align="left" onClick={e => e.stopPropagation()}>
                                                <IconButton size="small" onClick={(e) => handleOpenCaseOwnerDialog(e, row)}>
                                                    <EditIcon fontSize="small" />
                                                </IconButton>
                                            </TableCell>
                                        )}
                                    </TableRow>
                                )) : null}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Card>
            </Container>
            <Dialog open={caseOwnerDialogOpen && !mailOrbitEnabled} onClose={() => setCaseOwnerDialogOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>{t('lblEditCaseOwner') || 'Edit Case Owner'}</DialogTitle>
                <DialogContent>
                    {caseOwnerLoading ? (
                        <CircularProgress size={24} />
                    ) : (
                        <List>
                            {caseOwners.filter(owner => owner.EmployeeId !== caseOwnerRow?.CaseOwnerEmployeeId).map((owner) => (
                                <ListItem key={owner.EmployeeId} button onClick={() => handleSetCaseOwner(owner.EmployeeId)}>
                                    <ListItemText
                                        primary={owner.Dsc}
                                        secondary={`Active Cases: ${owner.ActiveCaseCount}`}
                                    />
                                    <ListItemSecondaryAction>
                                        <Chip
                                            size="small"
                                            label={owner.IsOnline ? 'Online' : 'Offline'}
                                            style={{ backgroundColor: owner.IsOnline ? '#4caf50' : '#9e9e9e', color: '#fff' }}
                                        />
                                    </ListItemSecondaryAction>
                                </ListItem>
                            ))}
                        </List>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setCaseOwnerDialogOpen(false)}>{t('btnCancel') || 'Cancel'}</Button>
                </DialogActions>
            </Dialog>
        </Page >
    );
}
export default connect(state => ({
    tasks: state.tasks1,
}), {
    getTasksRequest,
})(ExternalSystemTasks);
